import { GET_TOTEMS } from 'data/queries';
import { TotemUpdatedCacheHandlerParams } from 'types/cache.types';
import { TotemFragmentFragment as Totem } from 'data/__generated__';

export function totemUpdatedCacheHandler({
    apolloClient,
    currentTotem,
    totemUpdatedValues,
}: TotemUpdatedCacheHandlerParams): void {
    const result = apolloClient.readQuery({
        query: GET_TOTEMS,
    });
    const totems = result?.totemsOfUser;
    if (!Array.isArray(totems) || !currentTotem || !totemUpdatedValues) return;
    const totemsToUpdate = [...totems];
    const totemIds = totems.map((totem) => totem._id);
    const elemIndex = totemIds.indexOf(currentTotem._id ?? '');
    if (elemIndex === -1) return;
    const updatedTotem = { ...currentTotem, ...totemUpdatedValues };
    totemsToUpdate.splice(elemIndex, 1, updatedTotem as Totem);
    apolloClient.writeQuery({
        query: GET_TOTEMS,
        data: { totemsOfUser: totemsToUpdate },
    });
}
